import Common from './common.js';

const Validation = (function () {
  /**
   * Converts and checks value before adding it to DB or editing it in DB
   * @param {unknown{}[]} allFields
   * @param {boolean} validate
   * @param {unknown{}} value
   * @returns {unknown{}}
   * @throws
   */
  function convertAndCheck (allFields, validate = true, value) {
    const errors = [];

    allFields.forEach(field => {
      try {
        if (field.name.includes('.')) {
          const primaryKey = field.name.split('.')[0];
          const secondaryKey = field.name.split('.')[1];

          if (value[primaryKey][secondaryKey] === '') {
            if (field.type !== 'array') value[primaryKey][secondaryKey] = undefined;
            else value[primaryKey][secondaryKey] = [];
          }

          if (value[primaryKey][secondaryKey] !== undefined) {
            value[primaryKey][secondaryKey] = Common.convertAndCheckType(
              value[primaryKey][secondaryKey],
              field.type,
              field.labelSingular ? field.labelSingular : field.label,
            );

            if (validate) Common.checkProperties(value[primaryKey][secondaryKey], field);
          } else if (validate && field.required) {
            throw new Error(JSON.stringify({
              cs: `${field.label.cs} je povinné pole.`,
              en: `${field.label.en} is a required field.`,
            }));
          }
        } else {
          const key = field.name;

          if (value[key] === '') {
            if (field.type !== 'array') value[key] = undefined;
            else value[key] = [];
          }

          if (value[key] !== undefined) {
            value[key] = Common.convertAndCheckType(
              value[key],
              field.type,
              field.labelSingular ? field.labelSingular : field.label,
            );

            if (validate) Common.checkProperties(value[key], field);
          } else if (validate && field.required) {
            throw new Error(JSON.stringify({
              cs: `${field.label.cs} je povinné pole.`,
              en: `${field.label.en} is a required field.`,
            }));
          }
        }
      } catch (error) {
        errors.push({ message: JSON.parse(error.message), fieldName: field.name });
      }
    });

    if (value.timestamp?.date || value.timestamp?.time) {
      let date;
      let time;

      if (value.timestamp.date === '') value.timestamp.date = undefined;
      if (value.timestamp.time === '') value.timestamp.time = undefined;

      try {
        if (value.timestamp.date !== undefined) {
          date = Common.convertAndCheckType(value.timestamp.date, 'date', { cs: 'Datum plánovaného zveřejnění', en: 'Date of planned publication' });

          if (Common.formatDbDate(date) < Common.getDbDate()) {
            throw new Error(JSON.stringify({
              cs: `Datum plánovaného zveřejnění "${date}" nesmí být v minulosti.`,
              en: `Date of planned publication "${date}" must not be in the past.`,
            }));
          }
        } else {
          throw new Error(JSON.stringify({
            cs: 'Při použití plánovaného zveřejnění je třeba zadat datum i čas.',
            en: 'When using planned publication, you need to specify both the date and the time.',
          }));
        }
      } catch (error) {
        errors.push({ message: JSON.parse(error.message), fieldName: 'timestamp.date' });
      }

      try {
        if (value.timestamp.time !== undefined) {
          time = Common.convertAndCheckType(value.timestamp.time, 'time', { cs: 'Čas plánovaného zveřejnění', en: 'Time of planned publication' });

          if (!errors.map(error => error.fieldName).includes('timestamp.date')) {
            if (Common.formatDbDate(date) === Common.getDbDate() && Common.formatDbTime(time) < Common.getDbTime()) {
              throw new Error(JSON.stringify({
                cs: `Čas plánovaného zveřejnění "${time}" nesmí být v minulosti.`,
                en: `Time of planned publication "${time}" must not be in the past.`,
              }));
            }
          }
        } else {
          throw new Error(JSON.stringify({
            cs: 'Při použití plánovaného zveřejnění je třeba zadat datum i čas.',
            en: 'When using planned publication, you need to specify both the date and the time.',
          }));
        }
      } catch (error) {
        errors.push({ message: JSON.parse(error.message), fieldName: 'timestamp.time' });
      }

      if (!errors.map(error => error.fieldName).includes('timestamp.date') && !errors.map(error => error.fieldName).includes('timestamp.time')) {
        value.timestamp = Common.formatDbDate(date) + Common.formatDbTime(time);
      }
    } else {
      value.timestamp = undefined;
    }

    if (errors.length > 0) throw new AggregateError(errors);

    return value;
  }

  return {
    convertAndCheck,
  };
})();

export default Validation;
